export const joinPluginNames = (plugins) => (plugins ?? []).map((plugin) => plugin.name).join(', ');
export const getPluginGuids = (plugins) => (plugins ?? []).map((plugin) => plugin.guid);
export var SecretType;
(function (SecretType) {
    SecretType[SecretType["LOGIN"] = 1] = "LOGIN";
    SecretType[SecretType["PASSWORD"] = 2] = "PASSWORD";
    SecretType[SecretType["TOKEN"] = 3] = "TOKEN";
    SecretType[SecretType["SERVER"] = 4] = "SERVER";
    SecretType[SecretType["DATABASE_NAME"] = 5] = "DATABASE_NAME";
    SecretType[SecretType["HOST"] = 6] = "HOST";
    SecretType[SecretType["PORT"] = 7] = "PORT";
})(SecretType || (SecretType = {}));
